
  export default {
    mounted() {
      const chartData = JSON.parse(this.el.dataset.chartData || "[]")
      const currencySymbol = this.el.dataset.currencySymbol || "$"
      const i18n = JSON.parse(this.el.dataset.i18n || "null") || window.I18n || {}
      this.renderChart(chartData, i18n, currencySymbol)
    },
    renderChart(chartData, i18n, currencySymbol) {
      const t = (key) => i18n[key] || key
      const salesLabel = `${t("Sales")} (${currencySymbol})`
      if (chartData.length === 0) {
        this.el.innerHTML = `<div class="flex items-center justify-center h-full text-text-muted">${t("No retail data available")}</div>`
        return
      }

      import("highcharts").then((Highcharts) => {
        const categories = chartData.map(d => d.name)
        const salesData = chartData.map(d => d.total_sales ? parseFloat(d.total_sales.amount) / 100 : 0)
        const transactionsData = chartData.map(d => d.total_transactions)

        window.Enaia.applyHighchartsTheme(Highcharts.default)
        Highcharts.default.chart(this.el.id, {
          chart: {
            type: 'bar',
            backgroundColor: 'transparent'
          },
          title: { text: null },
          xAxis: {
            categories: categories,
            labels: {
              style: {
                fontSize: '12px',
                color: '#374151'
              }
            }
          },
          yAxis: [{
            min: 0,
            title: {
              text: salesLabel,
              style: { fontSize: '12px' }
            }
          }, {
            min: 0,
            title: {
              text: t("Transactions"),
              style: { fontSize: '12px' }
            },
            opposite: true
          }],
          legend: {
            enabled: true,
            align: 'center',
            verticalAlign: 'bottom'
          },
          tooltip: {
            shared: true,
            useHTML: true,
            formatter: function() {
              const location = this.x
              const sales = this.points[0]?.y || 0
              const transactions = this.points[1]?.y || 0
              return `<div style="padding: 8px;">
                <strong>${location}</strong><br/>
                ${salesLabel}: ${currencySymbol}${sales.toLocaleString()}<br/>
                ${t("Transactions")}: ${transactions.toLocaleString()}
              </div>`
            }
          },
          plotOptions: {
            bar: {
              borderRadius: 4,
              groupPadding: 0.1
            }
          },
          series: [{
            name: salesLabel,
            data: salesData,
            color: '#0086e6',
            yAxis: 0
          }, {
            name: t("Transactions"),
            data: transactionsData,
            color: '#F97316',
            yAxis: 1
          }],
          credits: { enabled: false }
        })
      })
    }
  }
